import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, download, fmtQty, fmtDT, TXN_LABELS } from "@/lib/api";
import { PageHeader, Empty, tableWrap, th, td, num } from "@/components/common";

export default function Ledger() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const params = { q, txn_type: type === "all" ? "" : type, date_from: from, date_to: to };
  useEffect(() => { api.get("/ledger", { params }).then((r) => setItems(r.data)); }, [q, type, from, to]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <PageHeader title="Stock Ledger" subtitle="Immutable movement history. Posted entries are corrected only by reversals or adjustments — never deleted.">
        <Button variant="outline" onClick={() => download(`/ledger/export.xlsx?${new URLSearchParams(params)}`, "Roxy_Inventory_Ledger.xlsx")} data-testid="ledger-export-btn"><Download className="h-4 w-4 mr-1" />Excel</Button>
      </PageHeader>
      <div className="flex flex-col sm:flex-row flex-wrap gap-2 mb-4">
        <Input placeholder="Search drum, reference, SKU, employee…" value={q} onChange={(e) => setQ(e.target.value)} className="sm:max-w-xs" data-testid="ledger-search-input" />
        <Select value={type} onValueChange={setType}><SelectTrigger className="sm:w-48" data-testid="ledger-type-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All types</SelectItem>{Object.entries(TXN_LABELS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent></Select>
        <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="sm:w-40" data-testid="ledger-from-input" />
        <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="sm:w-40" data-testid="ledger-to-input" />
      </div>
      <div className={tableWrap}>
        <table className="w-full" data-testid="ledger-table">
          <thead><tr>{["Seq", "Date", "Time", "Type", "Reference", "Brand", "Cable Size", "Drum", "Qty", "Drum Balance", "By"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
          <tbody>{items.map((l) => (
            <tr key={l.id} className="hover:bg-muted/40">
              <td className={`${td} font-mono`}>{l.seq}</td><td className={td}>{l.date}</td><td className={td}>{fmtDT(l.at)}</td><td className={td}>{TXN_LABELS[l.txn_type]}</td>
              <td className={`${td} font-mono`}>{l.ref_no}</td><td className={td}>{l.brand}</td><td className={td}>{l.cable_size}</td>
              <td className={`${td} font-mono`}><Link to={`/drums/${l.drum_id}`} className="hover:underline">{l.drum_code}</Link></td>
              <td className={`${td} ${num} ${l.qty < 0 ? "text-red-600" : ""}`}>{fmtQty(l.qty, l.uom)}</td><td className={`${td} ${num}`}>{fmtQty(l.drum_balance_after, l.uom)}</td><td className={td}>{l.by.name}</td>
            </tr>
          ))}</tbody>
        </table>
        {!items.length && <Empty text="No ledger movements" />}
      </div>
    </div>
  );
}
